import { Component } from '@angular/core';
import { SelectItem, LazyLoadEvent, Message, ConfirmationService } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { UserRewards } from '../../../models/inModels/Rewards';
import { NotificationContentType } from '../../../models/inModels/MessageModel';
import { RewardsService } from '../../../services/rewards/rewards.service';
import { AuthenticationService } from '../../../services/authentication/authentication.service';
import { DataTable } from 'primeng/components/datatable/datatable';

@Component({
  selector: 'app-redeemer',
  templateUrl: './redeemer.component.html',
  styleUrls: ['./redeemer.component.css']
})
export class RedeemerComponent {
  userReward: UserRewards[];
  rows: SelectItem[];
  selectedRows: number;
  filteredRecords: number;
	rowEvent: LazyLoadEvent;
	loading: boolean;
	totalRecords: number;
  error: Message[];
  contentId: number;
	contentType: NotificationContentType;
  sendAllDialog = false;
  id;
  filters;
  constructor(
    private route: ActivatedRoute,
		private rewardService: RewardsService,
		private router: Router,
		private confirmationService: ConfirmationService,
		private auth: AuthenticationService) {
    this.loading = true;
		this.rows = [];
		this.rows.push({ label: '10', value: 10 });
		this.rows.push({ label: '25', value: 25 });
		this.rows.push({ label: '50', value: 50 });
    this.selectedRows = 10;
    this.id = this.route.snapshot.paramMap.get('Id');
   }

  goBack(): void {
		this.router.navigate(['/rewards']);
	}
  
	changeRows(event): void {
		this.loadUserRewards(this.rowEvent);
	}
  reset(dt: DataTable, gb: HTMLInputElement) {
		gb.value = '';
		dt.reset();
  }
  loadUserRewards(event: LazyLoadEvent): void {
    this.loading = true;
    event.rows = this.selectedRows;
    console.log(event);
    event.filters['RewardsId'] = {value: this.id, matchMode: 'contains'}
    this.rowEvent = event;
    this.rewardService.search(event).then(
      dataPager => {
        this.userReward = dataPager.Data;
        console.log(this.userReward)
        this.filteredRecords = dataPager.FilteredRecords;
        this.totalRecords = dataPager.TotalRecords;
        this.loading = false;
      },
      error => {
        this.loading = false;
        this.userReward = [];
        this.totalRecords = 0;
        this.filteredRecords = 0;
        this.error = [];
        this.error.push({ severity: 'error', summary: 'Error', detail: error });
      });
  }
  sendAllDialogOpen(userReward: UserRewards) {
		this.contentId = userReward.RewardsId;
		this.contentType = NotificationContentType.Reward;
		this.sendAllDialog = true;
	}
}



// WEBPACK FOOTER //
// ./src/app/components/rewards/redeemer/redeemer.component.ts